// src/services/auth.js
import { hasConsent } from './consent.js'

async function apiCall(endpoint, options = {}) {
  if (!hasConsent()) {
    throw new Error('Keine Einwilligung zur Datenverarbeitung gegeben.')
  }

  const response = await fetch(`https://laubloch.de/backend/account.php${endpoint}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    ...options,
  });
  
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Ein Fehler ist aufgetreten');
  }
  
  return response.json();
}

export async function checkAuth() {
  try {
    const token = document.cookie
      .split('; ')
      .find(row => row.startsWith('auth_token='))
      ?.split('=')[1];
      
    if (!token) return { valid: false };
    
    return apiCall('?action=verify', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
  } catch (e) {
    console.error('Auth check failed:', e);
    return { valid: false };
  }
}

export async function loginWithKeyhole(file) {
  // Read the SVG file content
  const svgText = await file.text();
  
  return apiCall('?action=keyhole-login', {
    method: 'POST',
    body: JSON.stringify({ 
      svg: svgText
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export async function logout() {
  const token = document.cookie
    .split('; ')
    .find(row => row.startsWith('auth_token='))
    ?.split('=')[1];
    
  if (!token) return { success: true };
  
  const result = await apiCall('?action=logout', {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  // Clear cookies on successful logout
  if (result.success) {
    document.cookie = 'auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'login_method=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'login_keyhole=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    localStorage.removeItem('auth_keyhole');
  }
  
  return result;
}

export async function loginWithToken(token) {
  if (!token) throw new Error('Token fehlt');
  
  const response = await apiCall('?action=login-token', {
    method: 'POST',
    body: JSON.stringify({ token })
  });
  
  return response;
}

export async function loginWithEmail(email) {
  if (!email) throw new Error('E-Mail fehlt');
  if (!hasConsent()) throw new Error('Keine Einwilligung zur Datenverarbeitung gegeben.')

  // First request login token
  const loginResponse = await apiCall('?action=login', {
    method: 'POST',
    body: JSON.stringify({ email })
  });

  // Send login email
  const emailResponse = await fetch('https://laubloch.de/backend/login_mail.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email: email,
      token: loginResponse.login_token
    })
  });
  
  if (!emailResponse.ok) {
    const errorData = await emailResponse.json();
    throw new Error(errorData.error || 'E-Mail konnte nicht gesendet werden');
  }
  
  const emailResult = await emailResponse.json();
  
  return {
    success: true,
    message: 'Login-Link wurde per E-Mail gesendet',
    ...emailResult
  };
}